import styled from '@emotion/styled';
import { Colors } from '../../../colors';

export const CalendarStyled = {
  Container: styled.div<any>`
    .fc .fc-day-today {
      background-color: ${Colors.White} !important;
    }
    .fc-day-past {
      background-color: ${Colors.LightGrey} !important;
      color: grey !important;
    }
    .fc .fc-daygrid-day-top {
      opacity: 1
    }
    .fc-highlight {
      background-color: ${Colors.White} !important;
    }
    .fc-h-event {
      border: 0 !important;
    }
  `,
};
